/* Pastilles couleur posees en bas de la photo (choix user du 16/09 : meme hauteur
   pour toutes les cartes). Le rendu est fait cote SERVEUR dans la galerie ; ce
   fichier ne deplace plus rien, il ne fait que RECALER verticalement.

   Pourquoi du JS pour un centrage : les ronds sont slottes dans le shadow DOM
   d `overflow-list`, dont le `ul` porte une marge interne VARIABLE d une carte a
   l autre (7/7 sur l une, -3/17 sur une autre). Aucune constante CSS ne couvre
   les deux, et la page ne peut pas atteindre ce `ul`.

   Le declenchement est le vrai piege : le composant s hydrate tard, et apres un
   « Load more » 8 pilules sur 65 restaient a 3/11 parce que mes rendez-vous
   (0/250/800/2000 ms) tombaient AVANT l hydratation et que l observateur de
   taille ne voyait pas le changement. On balaie donc sur TOUS les evenements qui
   peuvent bouger la mise en page, en plus des rendez-vous.

   COUT MESURE le 18/09 (Lighthouse mobile, collection midi-dresses) : 1 247 ms
   de CPU, dont une tache longue de 291 ms — 3e poste de la page. La cause n est
   pas le nombre de pilules mais l ALTERNANCE lire/ecrire : chaque `mesurer`
   faisait `getBoundingClientRect` puis `style.transform` element par element,
   et le balayage au SCROLL rejouait ca sur 36 cartes toutes les 150 ms. Le
   navigateur recalcule la mise en page a chaque bascule (layout thrashing).
   Trois changements, sans toucher au resultat valide a l oeil :
     1. une passe de LECTURE complete, puis une passe d ECRITURE — une seule
        mise en page par rafale au lieu d une par element ;
     2. une pilule STABLE (deux passes d affilee sous 0,5 px) sort de la liste :
        le balayage ne porte plus que sur ce qui bouge encore ;
     3. les ecouteurs de scroll/resize se DECROCHENT quand la liste est vide,
        et se reposent si une carte arrive (filtre, tri, « Load more »). */
(function () {
  var PILULES = '.product-grid__item product-swatches, .product-grid-container product-swatches';
  var enCours = new Set();
  var accroche = false;

  function poser(racine) {
    var n = racine && racine.querySelectorAll ? racine : document;
    n.querySelectorAll(PILULES).forEach(suivre);
  }

  function suivre(sw) {
    if (sw.dataset.lvPosee === '1') return;
    sw.dataset.lvPosee = '1';
    sw.lvStable = 0;
    enCours.add(sw);
    accrocher();
    [0, 250, 800, 2000].forEach(function (d) {
      setTimeout(planifier, d);
    });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(planifier);
      ro.observe(sw);
      /* le HOTE garde 32px de haut quoi qu il arrive : c est le premier rond
         qui change de taille a l hydratation, donc c est LUI qu on surveille */
      var rond = sw.querySelector('.swatch');
      if (rond) ro.observe(rond);
      sw.lvRo = ro;
    }
    /* une carte hydratee hors ecran se recale a son entree dans l ecran */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (e, obs) {
        if (!e[0].isIntersecting) return;
        sw.lvStable = 0;
        enCours.add(sw);
        accrocher();
        planifier();
        setTimeout(planifier, 400);
        obs.unobserve(sw);
      }).observe(sw);
    }
  }

  /* Une seule rafale par image : toutes les lectures, PUIS toutes les ecritures. */
  var prevue = false;
  function planifier() {
    if (prevue || !enCours.size) return;
    prevue = true;
    requestAnimationFrame(passe);
  }

  /* 06/10 — LE « +N » DOIT TENIR SUR LA LIGNE DES RONDS. Liquid coupe la liste a
     8 pastilles, mais une carte mobile (179 px) n en loge que 5 : le conteneur
     passait a la ligne, le compteur tombait dessous, puis le recalage plus bas le
     REMONTAIT sur le premier rond (Elvenne « +1 » colle au 1er rond ; Seraphina
     « +16 », Veloura « +8 », Celestia « +12 » caches a gauche de la pilule).
     On range donc dans le compteur les ronds qui ne tiennent pas (et on les rend
     si la carte s elargit) ; le compte affiche = coupe Liquid + ronds ranges ici. */
  function ajuster(sw) {
    var cpt = sw.querySelector('.lv-pastilles-reste');
    var ol = sw.querySelector('overflow-list');
    if (!cpt || !ol || sw.getBoundingClientRect().width < 80) return false;
    if (!sw.dataset.lvReste) sw.dataset.lvReste = (cpt.textContent.match(/\d+/) || ['0'])[0];
    /* compteur et ronds sur UNE ligne, liste a la largeur de ses ronds */
    var f = cpt.parentElement;
    if (f.style.flexWrap !== 'nowrap') { f.style.flexWrap = 'nowrap'; ol.style.width = 'max-content'; ol.style.flex = '0 0 auto'; }
    var ecartF = parseFloat(getComputedStyle(f).columnGap) || 0;
    var cs = getComputedStyle(sw);
    var place = sw.parentElement.getBoundingClientRect().width - 16 - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    /* un rond range est masque par display:none (et non par slot="overflow") :
       hors grille, overflow-list reattribue lui-meme les slots et l annulait */
    var lis = [].slice.call(ol.querySelectorAll('li.variant-option__swatch'));
    var vus = lis.filter(function (li) { return li.slot !== 'overflow' && li.style.display !== 'none'; });
    var ranges = lis.filter(function (li) { return li.dataset.lvRange === '1'; });
    var change = false;
    /* largeur mesuree sur les RONDS visibles, pas sur la liste */
    var besoin = function () {
      var v = vus.filter(function (li) { return li.style.display !== 'none'; });
      if (!v.length) return 0;
      return v[v.length - 1].getBoundingClientRect().right - v[0].getBoundingClientRect().left + cpt.offsetWidth + ecartF + 6;
    };
    while (vus.length > 1 && besoin() > place) {
      var li = vus.pop();
      li.style.display = 'none';
      li.dataset.lvRange = '1';
      ranges.unshift(li);
      change = true;
    }
    while (!change && ranges.length && besoin() + 30 < place) {
      var r = ranges.shift();
      r.style.display = '';
      delete r.dataset.lvRange;
      vus.push(r);
      if (besoin() > place) { r.style.display = 'none'; r.dataset.lvRange = '1'; vus.pop(); break; }
      change = true;
    }
    var n = parseInt(sw.dataset.lvReste, 10) + lis.filter(function (li) { return li.dataset.lvRange === '1'; }).length;
    if (cpt.textContent !== '+' + n) cpt.textContent = '+' + n;
    return change;
  }

  window.lvAjusterPastilles = ajuster;

  function passe() {
    prevue = false;
    var travaux = [];
    /* les ajustements de largeur PASSENT AVANT la lecture des positions */
    enCours.forEach(function (sw) { if (sw.isConnected && ajuster(sw)) sw.lvStable = 0; });
    /* --- LECTURE seule : aucun style n est touche dans cette boucle --- */
    enCours.forEach(function (sw) {
      if (!sw.isConnected) { enCours.delete(sw); return; }
      var rond = sw.querySelector('.swatch');
      var enfants = [].slice.call(sw.children);
      if (!rond || !enfants.length) return;
      var h = sw.getBoundingClientRect();
      var r = rond.getBoundingClientRect();
      if (!h.height || !r.height) return;
      var ecart = (h.top + h.height / 2) - (r.top + r.height / 2);
      /* Le « +N » n est PAS un enfant direct de l hote : il vit dans le
         `fieldset` du picker, a cote d `overflow-list`. Le recalage des enfants
         deplace donc le compteur ET les ronds ENSEMBLE, et l ecart INTERNE entre
         les deux survit (mesure du 17/09 sur 39 compteurs : 35 a -5px, 4 a -1px).
         Il se lit ici et se corrige separement, contre le rond. */
      var cpt = sw.querySelector('.lv-pastilles-reste');
      var ecartCpt = 0;
      if (cpt) {
        var c = cpt.getBoundingClientRect();
        if (c.height) ecartCpt = (r.top + r.height / 2) - (c.top + c.height / 2);
      }
      travaux.push({ sw: sw, enfants: enfants, ecart: ecart, cpt: cpt, ecartCpt: ecartCpt });
    });
    /* --- ECRITURE seule : la mise en page n est recalculee qu une fois --- */
    travaux.forEach(function (t) {
      var bouge = false;
      if (Math.abs(t.ecart) >= 0.5) {
        bouge = true;
        t.enfants.forEach(function (e) { decaler(e, t.ecart); });
      }
      if (t.cpt && Math.abs(t.ecartCpt) >= 0.5) {
        bouge = true;
        decaler(t.cpt, t.ecartCpt);
      }
      /* deux passes d affilee sans correction = la carte a fini de bouger */
      t.sw.lvStable = bouge ? 0 : t.sw.lvStable + 1;
      if (t.sw.lvStable >= 2) {
        enCours.delete(t.sw);
        if (t.sw.lvRo) { t.sw.lvRo.disconnect(); t.sw.lvRo = null; }
      }
    });
    if (!enCours.size) decrocher();
  }

  function decaler(el, ecart) {
    var actuel = el.style.transform.match(/translateY\((-?[\d.]+)px\)/);
    var base = actuel ? parseFloat(actuel[1]) : 0;
    el.style.transform = 'translateY(' + (base + ecart).toFixed(2) + 'px)';
  }

  /* Les ecouteurs globaux ne restent accroches que tant qu une pilule bouge.
     C est ce qui evite de rejouer 36 mesures a chaque pas de scroll une fois la
     grille posee. */
  function accrocher() {
    if (accroche) return;
    accroche = true;
    window.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', planifier);
  }
  function decrocher() {
    if (!accroche) return;
    accroche = false;
    window.removeEventListener('scroll', planifier);
    window.removeEventListener('resize', planifier);
  }

  function demarrer() {
    poser(document);
    /* la grille se re-rend au filtrage, au tri et a la pagination */
    new MutationObserver(function (lots) {
      for (var i = 0; i < lots.length; i++) {
        var aj = lots[i].addedNodes;
        for (var j = 0; j < aj.length; j++) {
          if (aj[j].nodeType === 1) poser(aj[j].parentElement || aj[j]);
        }
      }
      planifier();
    }).observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('load', planifier);
    document.addEventListener('visibilitychange', planifier);
    /* les polices changent la hauteur du « +N » apres coup */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(planifier);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();

/* 05/10 — GARDE « tout dans +N » (signale par l user : cartes Charlise « +6 » et
   Delaria « +1 » sans aucune pastille). `overflow-list` range dans « +N » toute
   pastille qui passe a la ligne AU MOMENT de sa mesure ; mesuree pendant que la
   carte a une largeur nulle (carte cachee, en cours de rendu, retour arriere),
   TOUT bascule. Et comme notre CSS donne a la liste la largeur de son contenu
   (`width: max-content`, 16/09), sa taille ne change plus ensuite : le composant
   ne se recalcule jamais. Ce garde redemande un calcul (evenement `reflow`, prevu
   par le composant) quand une liste a TOUT en debordement alors que la carte a de
   la place — a l entree a l ecran, au retour arriere, et aux changements de grille. */
(function () {
  function bloquee(ol) {
    var lis = ol.querySelectorAll('li.variant-option__swatch');
    if (!lis.length) return false;
    for (var i = 0; i < lis.length; i++) if (lis[i].slot !== 'overflow') return false;
    /* la place se lit sur la CARTE : l hote des pastilles se retracte a la taille du « +N » */
    var carte = ol.closest('product-card, .product-card, li') || ol.parentElement;
    return carte && carte.getBoundingClientRect().width > 80;
  }
  function relancer(ol) {
    if (!bloquee(ol)) return;
    /* Un recalcul du composant ne sort PAS de cet etat (mesure du 05/10 : la liste interne
       reste figee a la largeur du « +N »). On remet donc nous-memes l'etat sain : autant
       de pastilles que la carte en contient, le reste dans « +N » avec le bon compte. */
    var lis = [].slice.call(ol.querySelectorAll('li.variant-option__swatch'));
    var carte = ol.closest('product-card, .product-card, li') || ol.parentElement;
    var place = carte.getBoundingClientRect().width - 44;
    var pas = 26; /* rond de 20 px + 6 px d'ecart (mesures du 05/10) */
    var k = Math.max(1, Math.min(lis.length, Math.floor(place / pas)));
    if (k < lis.length) k = Math.max(1, Math.floor((place - 28) / pas));
    var reste = lis.length - k;
    lis.forEach(function (li, i) { li.slot = i < k ? '' : 'overflow'; });
    var sr = ol.shadowRoot;
    var ul = sr && sr.querySelector('[part=list], ul');
    var more = sr && sr.querySelector('slot[name=more]');
    if (ul) {
      ul.style.removeProperty('flex-wrap');
      ul.style.setProperty('counter-reset', 'overflow-count ' + reste);
    }
    ol.style.setProperty('--overflow-count', String(reste));
    if (more) more.hidden = reste === 0;
    var ph = sr && sr.querySelector('[ref=placeholder], [part=placeholder]');
    if (ph) ph.hidden = true;
  }
  function balayer() {
    document.querySelectorAll('product-swatches overflow-list').forEach(relancer);
    /* 06/10 : cartes HORS grille (carrousels de l accueil) — le recalage ne les
       suit pas, mais le « +N » doit quand meme tenir sur la ligne */
    if (window.lvAjusterPastilles) document.querySelectorAll('product-swatches').forEach(function (sw) {
      if (!sw.closest('.product-grid__item, .product-grid-container')) window.lvAjusterPastilles(sw);
    });
  }
  var io = window.IntersectionObserver ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) setTimeout(function () { relancer(e.target); }, 50); });
  }) : null;
  function suivre(racine) {
    (racine || document).querySelectorAll && (racine || document).querySelectorAll('product-swatches overflow-list').forEach(function (ol) {
      if (ol.dataset.lvGarde) return;
      ol.dataset.lvGarde = '1';
      if (io) io.observe(ol);
    });
  }
  function demarrer() {
    suivre(document);
    [300, 1200, 3000, 6000, 10000, 15000].forEach(function (d) { setTimeout(balayer, d); });
    window.addEventListener('load', balayer);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) setTimeout(balayer, 100); });
    var defil = 0;
    window.addEventListener('scroll', function () {
      if (defil) return;
      defil = setTimeout(function () { defil = 0; balayer(); }, 800);
    }, { passive: true });
    window.addEventListener('pageshow', function () { setTimeout(balayer, 100); });
    window.addEventListener('resize', function () { setTimeout(balayer, 200); });
    var attente = 0;
    new MutationObserver(function () {
      clearTimeout(attente);
      attente = setTimeout(function () { suivre(document); balayer(); }, 250);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
